const isSameDay = (a: Date, b: Date) =>
    a.getDate() === b.getDate() &&
    a.getMonth() === b.getMonth() &&
    a.getFullYear() === b.getFullYear();

/**
 * Formats a date relative to now: time if today, "Yesterday" if yesterday,
 * otherwise a short date ("Jul 14").
 */
export const formatRelativeDate = (date: Date) => {
    if (Number.isNaN(date.getTime())) return '';

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    if (isSameDay(date, now)) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    if (isSameDay(date, yesterday)) {
        return 'Yesterday';
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

export const formatNotificationTime = (dateString: string) => {
    try {
        const formatted = formatRelativeDate(new Date(dateString.replace(' ', 'T')));
        return formatted || dateString;
    } catch (e) {
        return dateString;
    }
};
